import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import React, { useEffect, useState } from "react";
import { getUserData } from "../../utils/localStorage";
import { getStoreUserFullInfo } from "../../services/OrdersAPI/Orders";


const OrderInfoEditByProfile = ({
  orderInfoEditByProfileVisible,
  setOrderInfoEditByProfileVisible,
  editBy,
  
}) => {

  const [profileData,setProfileData] = useState("")
 
  const fetchStoreCustomerGetInfo = (editById) => {
   if(editById !== undefined) {
     getStoreUserFullInfo(editById)
     .then((response) => {
       if (!response.data.error) {
         const Res = response.data;
         setProfileData(Res);
        }
      })
      .catch((err) => {
        console.error("storeCustomerGetInfo Error:", err);
      });
  }
  };

  useEffect(() => {
      fetchStoreCustomerGetInfo(editBy);
  }, [orderInfoEditByProfileVisible]);


  const handleModalClose = () => {
    setOrderInfoEditByProfileVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={orderInfoEditByProfileVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!orderInfoEditByProfileVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-1 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #fff, #fff)",
              }}
            >
              <div></div>

              <p className=" text-3xl font-semibold" style={{color:"#1752AA"}}>
              Edited By - {profileData?.user?.fullName}
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-xl p-1 border-0"
                style={{color:"red"}}
              ></Button>
            </div>

            {/* <div>
              <div>
                <div className="px-4">
                  <div className="grid">
                    <div className="col">
                      <p className="text-xl text-center font-semibold capitalize"></p>
                    </div>
                  </div>

                </div>
              </div>
            </div> */}
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default OrderInfoEditByProfile;
